import * as Sentry from '@sentry/nextjs';

import { article as articleService } from '@boss/services/client';

const fetchStockByWarehouseIds = async ({
  skus,
  warehouseIds,
  locale,
}: {
  skus: {
    skuid: string;
    quantity?: number;
    unit?: string;
  }[];
  warehouseIds: string[];
  locale: string;
}) => {
  try {
    return await articleService.getArticleStockByWarehouseIds({ skus, warehouseIds, locale });
  } catch (e) {
    Sentry.captureException(e, {
      tags: {
        type: 'Fetch stock by warehouse ids',
      },
    });
  }
};

export { fetchStockByWarehouseIds };
